import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesCards from './components/ServicesCards';
import ServicesProcess from './components/ServicesProcess';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function Services() {
  useTitle({
    title: '服務項目｜保險建築師醫療、家庭、資產規劃',
    description: '保險建築師提供個人醫療保險、家庭保障規劃、資產與風險管理、企業團體方案與保單健檢等全方位服務。',
  });
  return (
    <main>
      <Navbar />
      <ServicesHero />
      <ServicesCards />
      <ServicesProcess />
      <PageCta />
      <Footer />
    </main>
  );
}
